module.exports = __webpack_public_path__ + "static/media/pameranMall.28a6f7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/image/pameranMall.jpg
// module id = 287
// module chunks = 0